// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1InjV","textarea":"styles_textarea__28OTj"};